import InvestorsTable from "./InvestorsTable"

export default InvestorsTable
